import { render, staticRenderFns } from "./CreateLayetteNewDetail.vue?vue&type=template&id=37af502c&style=display%3A%20inline-table%3B"
import script from "./CreateLayetteNewDetail.vue?vue&type=script&lang=js"
export * from "./CreateLayetteNewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports